import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import Faq1 from './Faq1';
import Faq2 from './Faq2';

class Faq extends React.Component{
  constructor (props){
    super(props);
  }

  render() {
    return (
      <div className="page-faq" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Faq"></MainTitle>
              <Faq1 />
              <Faq2 />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/classes/faq/Faq.js